/* eslint-disable */
export default {
  init() {

    function titleScroll() {
      var prevScrollpos = window.pageYOffset,
          siteHeader = document.querySelector('.c-main-header'),
          hero = $('.c-hero'),
          logoGroup = $('.c-main-header__logos'),
          projectTitle = $('.c-main-header__project'),
          siteHeaderHeight = siteHeader.offsetHeight,
          heroOffsetHeight = hero.offset().top - $(window).scrollTop()

      document.addEventListener('scroll', () => {

        // When the user scrolls down, show the project title.
        // When the user scrolls up, hide the project title.
        var currentScrollPos = window.pageYOffset,
            scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        if (scrollTop > heroOffsetHeight && scrollTop != 0) {
          projectTitle.addClass('is-shown');
          logoGroup.addClass('project-title-is-shown');
        }
        else {
          projectTitle.removeClass('is-shown');
          logoGroup.removeClass('project-title-is-shown');
        }

      });
    }

    function playVideoPromise() {
      $('video.is-autoplay').each(function() {
        var playPromise = $(this)[0].play();
        if (playPromise !== undefined) {
          playPromise.then(_ => {
            // Automatic playback started!
            // Show playing UI.
          })
          .catch(error => {
            // Auto-play was prevented
            // Show paused UI.
          });
        }
      });
    }

    function videoScrollPlay() {
      $(window).scroll(function() {
        $('video.is-autoplay').each(function() {
          if ($(this).visible(true)) {
            $(this)[0].play();
          } else {
            $(this)[0].pause();
          }
        })
      });
    }

    function slickMultipleCarousel() {

      $(".c-slick-slider").slick({
        dots: false,
        infinite: true,
        speed: 500,
        variableWidth: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        centerMode: true,
        focusOnSelect: true,
        centerPadding: '20%'
      });

    }

    function slickSingleCarousel() {
      $(".c-slick-single-slider").slick({
        dots: false,
        arrows: true,
        infinite: true,
        speed: 500,
        variableWidth: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        focusOnSelect: false,
        centerPadding: 0,
        responsive: [
          {
            breakpoint: 849,
            settings: {
              nextArrow: $('.c-slide__mobile-arrow')
            }
          }
        ]
      });
    }

    function playVideoManually() {
      $('.c-video-block').each(function() {
        var icon = $(this).find('.c-video-block__icon');
        var video = $(this).find('video')[0];
        if (icon.length > 0) {
          $(this).find('.c-video-block__icon').on('click', function(e){
            video.play();
            $(this).parent().find('video').attr('controls', '');
            $(this).remove();
            e.stopPropagation();
          });
          return true;
        }
      });
    }

    function ajaxNextPost() {
      $(document).on('click', '.c-next-project-section', function(event) {
        event.preventDefault();
        $('body').addClass('is-animating-body');
        $('.c-main-header__project').addClass('is-animating-project-title');
        $(this).addClass('is-animating-next-section');
        $(this).addClass('is-fixed');
        $(this).prev().addClass('is-animating-current-section');
        $(this).one('animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd', function(e) {
          $('body').removeClass('is-animating-body');
          var link = $('.c-next-project-section').attr('href');
          $('.l-main').load(link+' .c-projects-container', { async: false }, function(){
            $('.c-main-header__project').removeClass('is-animating-project-title is-shown');
            $('.c-next-project-section').removeClass('is-fixed');
            $('html').scrollTop(0);
            $('.c-main-header__project').html('+ ' + $('.c-project').attr('data-title'));
            $(document).prop('title', $('.c-project').attr('data-title') + ' - Aruliden')
            $(window).on('popstate', function (e) {
              location.reload();
            });
            const observer = lozad('.lozad', {
              load: function(el) {
                el.classList.add('fade');
              },
              rootMargin: '300px 0px',
              threshold: 0.3
            });
            titleScroll();
            observer.observe();
            playVideoManually();
            playVideoPromise();
            slickMultipleCarousel();
            slickSingleCarousel();
            history.pushState(null, null, link);
          });
        });
      });
    }

    titleScroll();
    playVideoPromise();
    videoScrollPlay();
    playVideoManually();
    ajaxNextPost();





  },
  finalize() {

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/single.js